import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';

export const getInspectStepsDataTableStructure = (): DynamicDataTable => {
  const idColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.dacScenarios.edit.steps.table.id',
    accessorKey: 'etapeId',
    variant: DataTableColumnVariant.TEXT,
  };

  const nameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.dacScenarios.edit.steps.table.nom',
    accessorKey: 'etapeNom',
    variant: DataTableColumnVariant.TEXT,
  };

  const typeDossierColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.dacScenarios.edit.steps.table.typeDossier',
    accessorKey: 'typeDossierLibelle',
    variant: DataTableColumnVariant.TEXT,
  };

  const modeEvaluationColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.dacScenarios.edit.steps.table.modeEvaluation',
    accessorKey: 'modeEvaluationCode',
    variant: DataTableColumnVariant.TEXT,
  };

  const orderEvaluationColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.dacScenarios.edit.steps.table.orderEvaluation',
    accessorKey: 'orderEvaluation',
    variant: DataTableColumnVariant.TEXT,
  };

  return {
    singular: 'settings.dacScenarios.table.step.singular',
    plural: 'settings.dacScenarios.table.step.plural',
    columns: [idColumn, nameColumn, typeDossierColumn, modeEvaluationColumn, orderEvaluationColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    searchableFields: ['etapeId', 'etapeNom', 'typeDossierLibelle', 'modeEvaluationCode', 'orderEvaluation'],
  };
};
